// src/components/Blocks/SocialMeta/Edit.jsx

import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';
import socialMetaSchema from './schema';

const messages = defineMessages({
  socialMeta: {
    id: 'socialMeta',
    defaultMessage: 'Social Media Meta',
  },
  socialMetaDescription: {
    id: 'socialMetaDescription', 
    defaultMessage: 'Configure social media sharing for this page',
  },
});

const SocialMetaEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const intl = useIntl();

  return (
    <>
      <div style={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '20px',
        margin: '10px 0',
        backgroundColor: '#f9f9f9',
        textAlign: 'center'
      }}>
        <div>
          <h3>{intl.formatMessage(messages.socialMeta)}</h3>
          <p>{intl.formatMessage(messages.socialMetaDescription)}</p>
          {data.social_custom_title && (
            <div><strong>Title:</strong> {data.social_custom_title}</div>
          )}
          {data.social_custom_description && (
            <div><strong>Description:</strong> {data.social_custom_description}</div>
          )}
          {!data.social_custom_title && !data.social_custom_description && (
            <div style={{ fontStyle: 'italic', color: '#666' }}>
              Configure social media settings in the sidebar →
            </div>
          )}
        </div>
      </div>

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={socialMetaSchema}
          title={intl.formatMessage(messages.socialMeta)}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
        />
      </SidebarPortal>
    </>
  );
};

export default SocialMetaEdit;